<template>
  <div>
    <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }"> {{$t('route.home')}}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'coachList' }">{{$t('entities.teamManager.plural')}}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'teamManagerShow', params: { id: model.id } }" v-if="model">{{ model.id }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('table.history')}}</el-breadcrumb-item>    </el-breadcrumb>

    <h2 class="page-title">{{$t('entities.teamManager.singular')}} history</h2>


    <el-form @submit.native.prevent class="search" :inline="true">
      <el-form-item>
        <el-input v-model="pager.search" :placeholder="$t('table.search')">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </el-form-item>
    </el-form>

    <el-table
      :data="pager.paginate(list)"
      :default-sort="{
        prop: 'modified',
        order: 'descending'
      }"
      empty-text="There is no history yet"
      @sort-change="(args) => pager.sortChange(args)"
      style="width: 100%"
      v-loading="loading"
      border
    >
      <el-table-column
        prop="modified"
        label="Updated at"
        width="180"
        sortable="custom"
      >
        <template slot-scope="scope">
          {{ scope.row.modified | formatDatetime }}
        </template>
      </el-table-column>

      <el-table-column
        label="Updated by"
        prop="modifiedBy.email"
        sortable="custom"
      ></el-table-column>

      <el-table-column
        prop="name"
        label="Name"
        sortable="custom"
      ></el-table-column>

      <el-table-column
        prop="lastName"
        label="LastName"
        sortable="custom"
      ></el-table-column>
      
      <el-table-column
        prop="dni"
        label="DNI/NIE/PASAPORTE"
        sortable="custom"
      ></el-table-column>

      <el-table-column
        prop="email"
        label="Email"
        sortable="custom"
      ></el-table-column>

      <el-table-column
        prop="dorsal"
        label="Dorsal"
        sortable="custom"
      ></el-table-column>

      <el-table-column
        prop="phone"
        label="Phone"
        sortable="custom"
      ></el-table-column>

      <el-table-column
        prop="position"
        label="Position"
      >
        <template slot-scope="scope">
          {{ scope.row.position ? scope.row.position.label : '' }}
        </template>
      </el-table-column>

      <el-table-column
        prop="namePublic"
        label="Nombre deportivo"
        sortable="custom"
      ></el-table-column>

      <el-table-column
        prop="created"
        label="Created at"
        width="180"
        sortable="custom"
      >
        <template slot-scope="scope">
          {{ scope.row.created | formatDatetime }}
        </template>
      </el-table-column>

      <el-table-column
        label="Created by"
        prop="createdBy.email"
        sortable="custom"
      ></el-table-column>

      <el-table-column
        prop="deleted"
        label="Deleted at"
        width="180"
        sortable="custom"
      >
        <template slot-scope="scope">
          {{ scope.row.deleted | formatDatetime }}
        </template>
      </el-table-column>

      <el-table-column
        label="Deleted by"
        prop="deletedBy.email"
        sortable="custom"
      ></el-table-column>
    </el-table>

    <div class="mt-3">
      <el-pagination
        style="float: right"
        @size-change="(args) => pager.pageSizeChange(args)"
        :current-page.sync="pager.currentPage"
        :layout="paginationLayout"
        :total="pager.filteredAndSortedList(list).length"
        background
      ></el-pagination>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'app-team-manager-history-single',

  props: {
    id: String,
  },

  computed: {
    ...mapGetters({
      loading: 'entities/team-manager/historySingle/loading',
      list: 'entities/team-manager/historySingle/list',
      pager: 'entities/team-manager/historySingle/pager',
      model: 'entities/team-manager/historySingle/model',
      paginationLayout: "shared/paginationLayout"
    }),
  },

  created() {
    this.$store.dispatch(
      'entities/team-manager/historySingle/setup',
      this.id,
    );
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch(
      'entities/team-manager/historySingle/clear',
    );
    next();
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/entities/team-manager/team-manager-history/team-manager-history-single/team-manager-history-single.vue?84dee7d4